import React from 'react'
import headerImg from "./header.svg"

const Header = () => {
    return (
        <div className="services-container-header">
            <div className="services-container-header-content">
                <img src={ headerImg } />
                <span>SEKTÖRLER</span>
            </div>
        </div>
    )
}

export default Header
